module.exports = __webpack_public_path__ + "img/vector-30.1e2104d5.svg";